import { ChatMessage } from "../../features/existing-chat/models/ChatMessage";
import { ChatReport } from "./ChatReport";
import { PrimaryChatMetadata } from "./PrimaryChatMetadata";

export enum ChatStatus {
  Finished = "finished",
  InProgress = "inProgress",
  Failed = "failed",
}

export class ChatShort {
  public id: string;
  public title: string;
  public isFailed: boolean;
  public startedAt: Date;
  public finishedAt?: Date;
  public metadata: PrimaryChatMetadata;

  constructor(response: any) {
    this.id = response.id as string;
    this.title = response.title as string;
    this.isFailed = response.isFailed as boolean;
    this.startedAt = new Date(response.startedAt);
    if (response.finishedAt) {
      this.finishedAt = new Date(response.finishedAt);
    }
    this.metadata = new PrimaryChatMetadata(response.metadata);
  }

  public get status(): ChatStatus {
    if (this.isFailed) {
      return ChatStatus.Failed;
    }
    if (this.finishedAt) {
      return ChatStatus.Finished;
    }
    return ChatStatus.InProgress;
  }

  public get inProgress() {
    return !this.finishedAt;
  }

  public get timeInterval() {
    //plus operator converts Date to number
    return this.finishedAt ? +this.finishedAt - +this.startedAt : undefined;
  }
}

export class Chat extends ChatShort {
  public messages: ChatMessage[];
  public report?: ChatReport;
  public suggestedQuestions?: string[];
  public canContinue: boolean;

  constructor(response: any) {
    super(response);
    this.messages = response.messages.map(
      (message: any) => new ChatMessage(message),
    );
    this.report = response.report ? new ChatReport(response.report) : undefined;
    this.suggestedQuestions = response.suggestedQuestions;
    this.canContinue = response.canContinue;
  }
}
